<template>
  <div class="animated fadeIn mt-5">
    <form
      enctype="multipart/form-data"
      v-on:submit="validateBeforeSubmit($event, false)"
      v-if="dataLoaded"
    >
    <b-card no-body>
      <b-tabs card>
        <b-tab title="Email">
        <b-row>
          <b-col md="6">
            <b-row>
              <b-col md="6">
                <b-form-fieldset label="Nome da campanha (interno)">
                  <b-form-input
                    type="text"
                    :readonly="item.state > 0"
                    name="name"
                    v-model="item.name"
                    placeholder="Nome da campanha (interno)"
                    v-validate="{ required: true }"
                    :state="validateState('name')"
                    data-vv-validate-on="change"
                  ></b-form-input>
                  <b-form-invalid-feedback>
                    {{ errors.first("name") }}
                  </b-form-invalid-feedback>
                </b-form-fieldset>
              </b-col>
              <b-col md="6">
                <b-form-group label="Estado">
                  <b-form-select v-model="item.state" disabled :options="states.campaigns.states"></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-form-fieldset label="Assunto">
              <b-form-input
                type="text"
                name="subject"
                :readonly="item.state > 0"
                v-model="item.subject"
                placeholder="Assunto"
                v-validate="{ required: true }"
                :state="validateState('subject')"
                data-vv-validate-on="change"
              ></b-form-input>
              <b-form-invalid-feedback>
                {{ errors.first("subject") }}
              </b-form-invalid-feedback>
            </b-form-fieldset>
          </b-col>
        </b-row>
        <b-form-group>

        </b-form-group>
        <b-row>
          <b-col md="6">
            <div v-if="item.state > 0">
              <pre>{{item.content_html}}</pre>
            </div>
            <div v-if="item.state == 0">
              <b-form-fieldset
                v-if="editorMode == 'markdown'"
                label="Template Markdown"
                :readonly="item.state > 0"
              >

            <b-btn
              variant="info"
              size="sm"
              @click="changeEditor('html')"
              v-if="editorMode == 'markdown'"
              >Editar em HTML</b-btn>
                <codemirror
                  v-model="item.content_markdown"
                  :options="cmOptionsMark"
                  :readonly="item.state > 0"
                />
                <p>
                  Formatação do texto em Markdown
                  <a
                    href="https://www.markdownguide.org/cheat-sheet/"
                    target="_blank"
                    >markdownguide.org</a
                  >
                </p>
              </b-form-fieldset>
              <b-form-fieldset label="Template HTML" v-if="editorMode == 'html'">
                <b-btn
              variant="info"
              size="sm"
              @click="changeEditor('markdown')"
              v-if="editorMode == 'html'"
              >Editar em Markdown</b-btn>
                <codemirror :readonly="item.state > 0" v-model="item.content_html" :options="cmOptions" />
              </b-form-fieldset>
              </div>
          </b-col>
          <b-col md="6">

                <b-table striped hover :items="activeReplacements" :fields="replacementFields">
                  <!-- A custom formatted column -->
                  <template #cell(str)="data">
                    {{ '{'+data.value+'}' }}
                  </template>
                </b-table>
          </b-col>
        </b-row>


        </b-tab>
        <b-tab title="Destinatários">
          <recipients ref="recipients" v-model="item.recipients" ></recipients>

        </b-tab>
        <b-tab title="Enviar">
          <p>Depois de enviar a campanha já não pode fazer mais alterações</p>
          <b-btn v-if="item.state == 0" variant="success" @click="showSendModal" ><i class="fa fa-send"></i> Gravar e Enviar</b-btn>
          <p v-if="item.state">A campanha foi enviada</p>

            <b-modal id="send-emails" hide-footer>
              <template v-slot:modal-title>
                Enviar campanha
              </template>
              <div class="d-block ">
                A campanha irá ser enviada. Esta ação não pode ser cancelada.
              </div>
              <b-button class="mt-3" @click="$bvModal.hide('send-emails')">Cancelar</b-button>
              <b-button variant="success" class="mt-3 pull-right" @click="sendEmails()">Enviar</b-button>
            </b-modal>

        </b-tab>
      </b-tabs>
              <div slot="footer">
          <div class="row">
            <div class="col-sm-3">
              <router-link
                :to="{ name: baseRoute + '.index' }"
                size="sm"
                variant="danger"
                ><i class="fa fa-ban"></i> Cancelar</router-link
              >
            </div>
            <div class="col-sm-9 text-right" v-if="item.state == 0">
              <b-button type="submit" size="sm" variant="primary"
                ><i class="fa fa-save"></i> Gravar</b-button
              >
              <b-button
                type="button"
                v-on:click="validateBeforeSubmit($event, true)"
                size="sm"
                variant="primary"
                ><i class="fa fa-save"></i> Gravar e fechar</b-button
              >
            </div>
          </div>
        </div>
      </b-card>

      <!--/.col-->
    </form>
  </div>
</template>

<script>
import marked from "marked";
import { codemirror } from "vue-codemirror";
import "codemirror/lib/codemirror.css";
import "codemirror/theme/material.css";
import "codemirror/mode/xml/xml.js";
import Lists from '@/components/Lists.js';
import Recipients from './recipients.vue'

var TurndownService = require("turndown").default;
console.log(TurndownService);

export default {
  name: "emailcampaignsEdit",
  props: ["id"],
  components: { codemirror, Recipients },
  data() {
    return {
      url: "email/campaigns",
      baseRoute: "emailcampaigns",
      dataLoaded: false,
      turndownService: null,
      activeReplacements: [{
        str: 'family_id',
        desc: 'ID da família',
      }, {
        str: 'surname',
        desc: 'Apelido',
      }, {
        str: 'username',
        desc: 'Nome de utilizador'
      }],
      states: Lists,
      editorMode: "markdown",
      cmOptions: {
        tabSize: 4,
        mode: "text/html",
        theme: "material",
        lineNumbers: true,
        line: true,
        // more CodeMirror options...
      },
      cmOptionsMark: {
        tabSize: 4,
        mode: "text/x-markdown",
        theme: "material",
        lineNumbers: true,
        line: true,
        // more CodeMirror options...
      },
      replacementFields: [{
        key: 'str',
        label: 'Variavel'
      }, {
        key: 'desc',
        label: 'Descrição'
      }],
      item: {
        name: "",
        state: 0,
        content_markdown: "",
        content_html: "",
        subject: "",
        recipients: {
          type: 1,
          conditions: [{
            operator: Lists.campaigns.recipientConditionsOperator[0],
            conditions: [{type: null, values:[]}]
          }]
        }
      },
    };
  },
  computed: {
    compiledTemplate: function () {
      if (this.editorMode == "markdown") {
        return marked(this.item.content_markdown, { sanitize: false });
      }
      return this.item.content_html;
    },

  },
  methods: {
    showSendModal(e) {
      this.validateBeforeSubmit(e, false)
      this.$bvModal.show('send-emails')
    },
    changeEditor(editorMode) {
      if (this.editorMode == "html") {
        this.item.content_markdown = this.turndownService.turndown(
          this.item.content_html
        );
      }
      if (this.editorMode == "markdown") {
        this.item.content_html = marked(this.item.content_markdown, {
          sanitize: false,
        });
      }
      this.editorMode = editorMode;
    },
    selectActivity(e) {
      if (e.item) {
        console.log(e.item);
        this.item.activity_id = e.item.id;
        this.item.activity.data = e.item;
      } else {
        this.item.activity_id = null;
        this.item.activity.data = { id: null, name: null };
      }
    },
    validateBeforeSubmit(evt, close) {
      evt.preventDefault();
      console.log("check validation");
      this.$validator.validateAll().then((result) => {
        console.log("validation results:", result);
        if (result) {
          console.log("all fields ok. submit");
          this.submit(evt, close);
          return;
        }
        this.$bvToast.toast("Tem campos inválidos", {
          autoHideDelay: 5000,
          variant: "danger",
          solid: true,
        });
      });
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.errors.has(ref);
      }
      return null;
    },
    submit(e, close) {
      e.preventDefault();
      if (this.editorMode == "markdown") {
        this.item.content_html = marked(this.item.content_markdown, {
          sanitize: false,
        });
      }
      var data = {
        data: this.item,
      };
      if (this.item.id) {
        this.axios
          .put(this.url + "/" + this.item.id, data)
          .then((response) => {
            this.item = response.data.data;
            this.$bvToast.toast("item gravado com sucesso", {
              autoHideDelay: 5000,
              variant: "success",
              solid: true,
            });
            if (close) {
              this.$router.push({
                name: this.baseRoute + ".index",
              });
            }
          })
          .catch((response) => {
            this.$bvToast.toast("Não foi possivel gravar", {
              autoHideDelay: 5000,
              variant: "danger",
              solid: true,
            });
          });
      } else {
        this.axios
          .post(this.url, data)
          .then((response) => {
            this.item = response.data.data;
            this.$bvToast.toast("item gravado com sucesso", {
              autoHideDelay: 5000,
              variant: "success",
              solid: true,
            });
            this.$router.push({
              name: this.baseRoute + ".edit",
              params: {
                id: this.item.id,
              },
            });
          })
          .catch((response) => {
            this.$bvToast.toast("Não foi possivel gravar", {
              autoHideDelay: 5000,
              variant: "danger",
              solid: true,
            });
          });
      }
    },
    sendEmails() {
      this.axios.post('email/campaigns/send/' + this.item.id, {} ).then(response => {
        this.$bvModal.hide('send-emails')
      })
    }
  },
  created() {
    var id = this.$route.params.id;
    let calls = []
    let callbacks = []
    let that = this


    if (typeof id !== "undefined") {
      calls.push(that.axios.get(that.url + "/" + id))
      callbacks.push(function(response) {
          that.item = response.data;
          if (that.item.allow_markdonw == 0) {
            that.editorMode = "html";
          }
      })
    }
     that.axios.all(calls)
     .then(that.axios.spread((...args) => {
        for (let i = 0; i < args.length; i++) {
            callbacks[i](args[i].data)
        }
        that.dataLoaded = true;
    })).catch((response) => {
          that.$bvToast.toast("Esta actividade não existe", {
            autoHideDelay: 5000,
            variant: "danger",
            solid: true,
          });
          that.$router.push({
            name: that.baseRoute + ".index",
          });
        });


  },
  mounted() {
    this.turndownService = new TurndownService();
  },
};
</script>
